export default __webpack_public_path__ + "static/12_18-cdf00e9a7180cc381cea1e2889411287.png";